import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Menu } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { strings as Localization } from '../../../lib/Localization';
import ListOptions from '../ListOptions/ListOptions';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));


const NavbarMenu = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                aria-controls="customized-menu"
                aria-haspopup="true"
                onClick={handleClick}
                startIcon={<PersonIcon />}
                endIcon={<ExpandMoreIcon />}
                style={{ height: 40 }}
            >
                {Localization.account}
            </Button>
            <StyledMenu
                id="customized-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onClick={handleClose}
            >
                <ListOptions button />
            </StyledMenu>
        </div>
    );
}

export default NavbarMenu;
